export default {
  'pages.login.success': 'Login successful!',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.username.placeholder': 'Username',
  'pages.login.username.required': 'Please enter your username!',
  'pages.login.password.placeholder': 'Password',
  'pages.login.password.required': 'Please enter your password!',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password?',
  'pages.login.forgotPasswordInfo':
    'Please contact administrator to reset password',
  'pages.login.submit': 'Login',
  'pages.login.back': 'Back',
  'pages.login.emailCheck.title': 'Email Verification',
  'pages.login.emailCheck.description':
    'A 6-digit code has been sent to {email}',
  'pages.login.emailCheck.sent':
    'A verification code has been sent to your email',
  'pages.login.tfaCheck.title': 'Two-Factor Authentication',
  'pages.login.tfaCheck.description':
    'Enter the 6-digit code from your authenticator app',
  'pages.login.verifyCode.submit': 'Verify',
  'pages.login.verifyCode.invalid': 'Invalid verification code',
  'pages.login.oidc.divider': 'Or continue with',
  'pages.login.oidc.continueWith': 'Continue with {provider}',
  'pages.login.oidc.authFailed': 'OIDC login failed',
  'pages.login.passkey.login': 'Sign in with Passkey',
  'pages.login.passkey.failed': 'Passkey verification failed',
  'pages.devices.list': 'Device List',
  'pages.devices.os': 'OS',
  'pages.devices.version': 'Client Version',
  'pages.devices.memory': 'Memory',
  'pages.devices.lastOnline': 'Last Online',
  'pages.devices.createdAt': 'Created At',
  'pages.devices.status': 'Status',
  'pages.devices.user': 'User',
  'pages.devices.deviceGroup': 'Group',
  'pages.devices.note': 'Note',
  'pages.devices.online': 'Online',
  'pages.devices.offline': 'Offline',
  'pages.devices.days': 'days',
  'pages.devices.hours': 'hours',
  'pages.devices.minutes': 'minutes',
  'pages.devices.justNow': 'just now',
  'pages.devices.enable': 'Enable',
  'pages.devices.disable': 'Disable',
  'pages.devices.enableSuccess': 'Device enabled',
  'pages.devices.enableFailed': 'Failed to enable device',
  'pages.devices.disableSuccess': 'Device disabled',
  'pages.devices.disableFailed': 'Failed to disable device',
  'pages.devices.deleteSuccess': 'Device deleted',
  'pages.devices.deleteFailed': 'Failed to delete device',
  'pages.devices.deleteConfirm': 'Are you sure to delete this device?',
  'pages.devices.block': 'Block',
  'pages.devices.blockConfirm':
    'Are you sure to block this device? Its active connections will be forcibly terminated.',
  'pages.devices.blockTip':
    'Block connections: this device cannot connect to others, active sessions are terminated',
  'pages.devices.blockSuccess': 'Device blocked',
  'pages.devices.blockFailed': 'Failed to block device',
  'pages.devices.unblock': 'Unblock',
  'pages.devices.unblockConfirm': 'Are you sure to unblock this device?',
  'pages.devices.unblockSuccess': 'Device unblocked',
  'pages.devices.unblockFailed': 'Failed to unblock device',
  'pages.devices.blockedTag': 'blocked',
  'pages.devices.autoRegistered': 'no agent',
  'pages.devices.source': 'Source',
  'pages.devices.sourceHeartbeat': 'managed (heartbeat)',
  'pages.devices.blocked': 'Blocked',
  'pages.devices.blockedYes': 'Blocked',
  'pages.devices.blockedNo': 'Not blocked',
  'pages.devices.deviceInfo': 'username@device_name',
  'pages.devices.strategyInfo': 'Strategy Info',
  'pages.devices.device': 'Device',
  'pages.devices.strategy': 'Strategy',
  'pages.devices.info': 'Info',
  'pages.devices.statusNormal': 'Normal',
  'pages.devices.statusDisabled': 'Disabled',
  'pages.devices.onlineStatus': 'Online Status',
  'pages.devices.deviceGroupSearchTip': 'Filter by device group name',
  'pages.devices.remove': 'Remove',
  'pages.devices.removeFromGroupSuccess': 'Device removed from group',
  'pages.devices.removeFromGroupFailed': 'Failed to remove device from group',
  'pages.devices.removeFromGroupConfirm':
    'Are you sure to remove this device from the group?',
  'pages.devices.batchRemove': 'Batch Remove',
  'pages.devices.batchRemoveFromGroupSuccess':
    'Successfully removed {count} device(s) from group',
  'pages.devices.batchRemoveFromGroupFailed':
    'Failed to remove devices from group',
  'pages.devices.batchRemoveFromGroupConfirm':
    'Are you sure to remove selected devices from the group?',
  'pages.devices.batchEnable': 'Batch Enable',
  'pages.devices.batchDisable': 'Batch Disable',
  'pages.devices.batchEnableConfirm':
    'Are you sure to enable selected devices?',
  'pages.devices.batchDisableConfirm':
    'Are you sure to disable selected devices?',
  'pages.devices.batchEnableSuccess': 'Successfully enabled {count} device(s)',
  'pages.devices.batchEnableFailed': 'Failed to enable devices',
  'pages.devices.batchEnablePartialFailed':
    'Successfully enabled {success} device(s), {failed} failed',
  'pages.devices.batchDisableSuccess':
    'Successfully disabled {count} device(s)',
  'pages.devices.batchDisableFailed': 'Failed to disable devices',
  'pages.devices.batchDisablePartialFailed':
    'Successfully disabled {success} device(s), {failed} failed',
  'pages.devices.edit': 'Edit Device',
  'pages.devices.updateSuccess': 'Device updated',
  'pages.devices.updateFailed': 'Failed to update device',
  'pages.devices.selectUser': 'Select user',
  'pages.devices.selectDeviceGroup': 'Select device group',
  'pages.devices.selectStrategy': 'Select strategy',
  'pages.addressBook.name': 'Name',
  'pages.addressBook.note': 'Note',
  'pages.addressBook.shared': 'Shared Address Books',
  'pages.addressBook.create': 'Create Address Book',
  'pages.addressBook.edit': 'Edit Address Book',
  'pages.addressBook.personal': 'Personal Address Book',
  'pages.addressBook.currentAddressBook': 'Address book',
  'pages.addressBook.myAddressBook': 'My address book',
  'pages.addressBook.loadFailed': 'Failed to load address books',
  'pages.addressBook.addPeer': 'Add by ID',
  'pages.addressBook.addTag': 'Add Tag',
  'pages.addressBook.tagName': 'Tag Name',
  'pages.addressBook.tagAdded': 'Tag added',
  'pages.addressBook.tagAddFailed': 'Failed to add tag',
  'pages.addressBook.tagDeleted': 'Tag deleted',
  'pages.addressBook.tagDeleteFailed': 'Failed to delete tag',
  'pages.addressBook.deleteTagConfirm': 'Are you sure to delete this tag?',
  'pages.addressBook.tagModeUnion': 'Any',
  'pages.addressBook.tagModeIntersection': 'All',
  'pages.addressBook.importDevices': 'Import from Devices',
  'pages.addressBook.importSuccess': 'Successfully imported {count} device(s)',
  'pages.addressBook.importPartialFailed': '{count} device(s) failed to import',
  'pages.addressBook.createSuccess': 'Address book created',
  'pages.addressBook.createFailed': 'Failed to create address book',
  'pages.addressBook.updateSuccess': 'Address book updated',
  'pages.addressBook.updateFailed': 'Failed to update address book',
  'pages.addressBook.deleteSuccess': 'Address book(s) deleted',
  'pages.addressBook.deleteFailed': 'Failed to delete address book(s)',
  'pages.addressBook.deleteConfirm':
    'Are you sure to delete this address book?',
  'pages.addressBook.batchDeleteConfirm':
    'Are you sure to delete selected address books?',
  'pages.addressBook.device': 'Device',
  'pages.addressBook.alias': 'Alias',
  'pages.addressBook.tags': 'Tags',
  'pages.addressBook.peerAdded': 'Peer added',
  'pages.addressBook.peerAddFailed': 'Failed to add peer',
  'pages.addressBook.peerDeleted': 'Peer deleted',
  'pages.addressBook.peerDeleteFailed': 'Failed to delete peer',
  'pages.addressBook.deletePeerConfirm': 'Are you sure to delete this peer?',
  'pages.addressBook.import': 'Import from Devices',
  'pages.addressBook.recycleBin': 'Recycle Bin',
  'pages.deviceGroups.list': 'Device Groups',
  'pages.deviceGroups.name': 'Name',
  'pages.deviceGroups.note': 'Note',
  'pages.deviceGroups.create': 'Create Device Group',
  'pages.deviceGroups.edit': 'Edit Device Group',
  'pages.deviceGroups.createSuccess': 'Device group created',
  'pages.deviceGroups.createFailed': 'Failed to create device group',
  'pages.deviceGroups.updateSuccess': 'Device group updated',
  'pages.deviceGroups.updateFailed': 'Failed to update device group',
  'pages.deviceGroups.deleteSuccess': 'Device group deleted',
  'pages.deviceGroups.deleteFailed': 'Failed to delete device group',
  'pages.deviceGroups.deleteConfirm':
    'Are you sure to delete this device group?',
  'pages.deviceGroups.import': 'Import',
  'pages.deviceGroups.importDevices': 'Import Devices',
  'pages.deviceGroups.importSuccess': 'Successfully imported {count} device(s)',
  'pages.deviceGroups.importFailed': 'Failed to import devices',
  'pages.users.list': 'User List',
  'pages.users.name': 'Name',
  'pages.users.displayName': 'Display Name',
  'pages.users.email': 'Email',
  'pages.users.note': 'Note',
  'pages.users.status': 'Status',
  'pages.users.create': 'Create User',
  'pages.users.enable': 'Enable',
  'pages.users.disable': 'Disable',
  'pages.users.enableSuccess': 'User enabled',
  'pages.users.enableFailed': 'Failed to enable user',
  'pages.users.disableSuccess': 'User disabled',
  'pages.users.disableFailed': 'Failed to disable user',
  'pages.users.createSuccess': 'User created',
  'pages.users.createFailed': 'Failed to create user',
  'pages.users.deleteSuccess': 'User deleted',
  'pages.users.deleteFailed': 'Failed to delete user',
  'pages.users.deleteConfirm': 'Are you sure to delete this user?',
  'pages.audits.conn': 'Connection Audits',
  'pages.audits.file': 'File Transfer Logs',
  'pages.audits.alarm': 'Alarm Audits',
  'pages.audits.console': 'Console Audits',
  'pages.audits.requestedAt': 'Requested At',
  'pages.audits.establishedAt': 'Established At',
  'pages.audits.closedAt': 'Closed At',
  'pages.audits.from': 'From',
  'pages.audits.fromName': 'From Name',
  'pages.audits.to': 'To',
  'pages.audits.toName': 'To Name',
  'pages.audits.action': 'Action',
  'pages.audits.time': 'Time',
  'pages.audits.alarmType': 'Alarm Type',
  'pages.audits.user': 'User',
  'pages.audits.detail': 'Detail',
  'pages.audits.type': 'Type',
  'pages.audits.connType.remoteDesktop': 'Remote Desktop',
  'pages.audits.connType.fileTransfer': 'File Transfer',
  'pages.audits.connType.portTransfer': 'Port Transfer',
  'pages.audits.connType.viewCamera': 'View Camera',
  'pages.audits.connType.terminal': 'Terminal',
  'pages.audits.connType.notLoggedIn': 'Not Logged In',
  'pages.audits.active': 'active',
  'pages.audits.duration': 'Duration',
  'pages.audits.note': 'Note',
  'pages.audits.disconnect': 'Disconnect',
  'pages.audits.disconnectSuccess': 'Successfully disconnected!',
  'pages.audits.disconnectFailed': 'Disconnect failed!',
  'pages.audits.disconnectConfirmTitle': 'Confirm Operation',
  'pages.audits.disconnectConfirmTip':
    'Are you sure you want to disconnect this device?',
  'pages.audits.updateSuccess': 'Update is successful',
  'pages.audits.updateFailed': 'Update failed, please try again!',
  'pages.audits.exportCSV': 'Export CSV',
  'pages.audits.noDataToExport': 'No data to export',
  'pages.audits.exportSuccess': 'Export successful',
  'pages.audits.exportFailed': 'Export failed',
  'pages.audits.exportConfirmTitle': 'Export CSV',
  'pages.audits.exportConfirmContent': 'Export up to 1000 records. Continue?',
  'pages.audits.remote': 'Remote',
  'pages.audits.local': 'Local',
  'pages.audits.direction': 'Direction',
  'pages.audits.files': 'Files',
  'pages.audits.remoteTip': 'Remotely controlled computer or terminal',
  'pages.audits.remoteSearchTip': 'Search by remote device ID (fuzzy match)',
  'pages.audits.remotePlaceholder': 'Enter remote device ID',
  'pages.audits.pathTip': 'Path of Remote Device',
  'pages.audits.exportCsvTip': 'Export up to 1000 records at a time',
  'pages.audits.limitedTip': 'Show the 10 largest files by size',
  'pages.audits.startTime': 'Start Time',
  'pages.audits.endTime': 'End Time',
  'pages.audits.alarmType.ipWhitelist': 'IP Not in Whitelist',
  'pages.audits.alarmType.exceedThirtyAttempts':
    'Same IP Exceeds 30 Failed Attempts',
  'pages.audits.alarmType.sixAttemptsWithinOneMinute':
    'More Than 6 Attempts Within 1 Minute',
  'pages.audits.alarmType.exceedIpv6PrefixAttempts':
    'IPv6 Prefix Attempt Limit Exceeded',
  'pages.audits.alarmType.terminalOsLoginBackoff':
    'Terminal OS Login Blocked by Backoff',
  'pages.audits.alarmType.terminalOsLoginConcurrency':
    'Terminal OS Login Concurrency Limit Exceeded',
  'pages.common.action': 'Action',
  'pages.common.delete': 'Delete',
  'pages.common.edit': 'Edit',
  'pages.common.batchDelete': 'Batch Delete',
  'pages.common.download': 'Download',
  'pages.common.more': 'More',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist',
  'pages.404.buttonText': 'Back to Home',
  'pages.customClients.list': 'Custom Client List',
  'pages.customClients.name': 'Client Name',
  'pages.customClients.createdAt': 'Created At',
  'pages.customClients.create': 'Create Custom Client',
  'pages.customClients.edit': 'Edit Custom Client',
  'pages.customClients.deleteConfirm':
    'Are you sure to delete this custom client?',
  'pages.customClients.createSuccess': 'Custom client created',
  'pages.customClients.createFailed': 'Failed to create custom client',
  'pages.customClients.updateSuccess': 'Custom client updated',
  'pages.customClients.updateFailed': 'Failed to update custom client',
  'pages.customClients.deleteSuccess': 'Custom client deleted',
  'pages.customClients.deleteFailed': 'Failed to delete custom client',
  'pages.customClients.downloadFailed': 'Failed to download client',
  'pages.userGroups.list': 'User Group List',
  'pages.userGroups.name': 'Group Name',
  'pages.userGroups.note': 'Note',
  'pages.userGroups.userCount': 'User Count',
  'pages.userGroups.create': 'Create User Group',
  'pages.userGroups.edit': 'Edit User Group',
  'pages.userGroups.deleteConfirm': 'Are you sure to delete this user group?',
  'pages.userGroups.createSuccess': 'User group created',
  'pages.userGroups.createFailed': 'Failed to create user group',
  'pages.userGroups.updateSuccess': 'User group updated',
  'pages.userGroups.updateFailed': 'Failed to update user group',
  'pages.userGroups.deleteSuccess': 'User group deleted',
  'pages.userGroups.deleteFailed': 'Failed to delete user group',
  'pages.userGroups.loadFailed': 'Failed to load user groups',
  'pages.userGroups.default': 'Default',
  'pages.userGroups.members': 'Members',
  'pages.userGroups.membersTitle': '{name} members',
  'pages.userGroups.currentMembers': 'Current members',
  'pages.userGroups.addUsers': 'Add users',
  'pages.userGroups.destination': 'Destination group',
  'pages.userGroups.selectDestination': 'Select destination group',
  'pages.userGroups.moveSelected': 'Move selected',
  'pages.userGroups.addSelected': 'Add selected users',
  'pages.userGroups.membersUpdated': 'Updated {count} user(s)',
  'pages.userGroups.membersUpdateFailed': 'Failed to update group members',
  'pages.users.userGroup': 'User Group',
  'pages.users.selectUserGroup': 'Select user group',
  'pages.addressBook.groupAccess': 'Group access',
  'pages.addressBook.groupAccessTitle': '{name} group access',
  'pages.addressBook.userGroup': 'User group',
  'pages.addressBook.permission': 'Permission',
  'pages.addressBook.permissionRead': 'Read only',
  'pages.addressBook.permissionReadWrite': 'Read and write',
  'pages.addressBook.permissionFull': 'Full control',
  'pages.addressBook.addGroupAccess': 'Add group access',
  'pages.addressBook.groupAccessLoadFailed': 'Failed to load group access',
  'pages.addressBook.groupAccessAdded': 'Group access added',
  'pages.addressBook.groupAccessAddFailed': 'Failed to add group access',
  'pages.addressBook.groupAccessUpdated': 'Group access updated',
  'pages.addressBook.groupAccessUpdateFailed': 'Failed to update group access',
  'pages.addressBook.groupAccessDeleted': 'Group access deleted',
  'pages.addressBook.groupAccessDeleteFailed': 'Failed to delete group access',
  'pages.addressBook.groupAccessDeleteConfirm': 'Delete this group access?',
  'pages.addressBook.shareAccess': 'Share',
  'pages.addressBook.accessTitle': '{name} - Access management',
  'pages.addressBook.shareType': 'Share type',
  'pages.addressBook.shareTarget': 'Target',
  'pages.addressBook.shareTypeEveryone': 'Everyone',
  'pages.addressBook.shareTypeUser': 'User',
  'pages.addressBook.shareTypeGroup': 'User group',
  'pages.addressBook.selectUser': 'Select user',
  'pages.addressBook.selectUserPlaceholder': 'Search by username or email',
  'pages.addressBook.everyoneHint':
    'All users will have access to this address book',
  'pages.addressBook.allUsers': 'All users',
  'pages.addressBook.addAccess': 'Add access',
  'pages.addressBook.accessLoadFailed': 'Failed to load access rules',
  'pages.addressBook.accessAdded': 'Access rule added',
  'pages.addressBook.accessAddFailed': 'Failed to add access rule',
  'pages.addressBook.accessUpdated': 'Access rule updated',
  'pages.addressBook.accessUpdateFailed': 'Failed to update access rule',
  'pages.addressBook.accessDeleted': 'Access rule deleted',
  'pages.addressBook.accessDeleteFailed': 'Failed to delete access rule',
  'pages.addressBook.accessDeleteConfirm': 'Delete this access rule?',
  'pages.roles.list': 'Role List',
  'pages.roles.name': 'Role Name',
  'pages.roles.note': 'Note',
  'pages.roles.permissions': 'Permissions',
  'pages.roles.permissionsInfo': 'Number of assigned permissions',
  'pages.roles.create': 'Create Role',
  'pages.roles.edit': 'Edit Role',
  'pages.roles.deleteConfirm': 'Are you sure to delete this role?',
  'pages.roles.selectPermissions': 'Select Permissions',
  'pages.roles.createSuccess': 'Role created successfully',
  'pages.roles.createFailed': 'Failed to create role',
  'pages.roles.updateSuccess': 'Role updated successfully',
  'pages.roles.updateFailed': 'Failed to update role',
  'pages.roles.deleteSuccess': 'Role deleted successfully',
  'pages.roles.deleteFailed': 'Failed to delete role',
  'pages.settings.title': 'System Settings',
  'pages.settings.save': 'Save Settings',
  'pages.settings.general': 'General Settings',
  'pages.settings.siteName': 'Site Name',
  'pages.settings.platformName': 'Platform Name',
  'pages.settings.platformNameTip':
    'Shown in the browser tab and header of the admin panel',
  'pages.settings.logoUrl': 'Logo',
  'pages.settings.logoUrlTip':
    'Logo image shown in the header of the admin panel',
  'pages.settings.logoUpload': 'Upload Logo',
  'pages.settings.logoUploadSuccess': 'Logo uploaded successfully',
  'pages.settings.logoUploadFailed': 'Failed to upload logo',
  'pages.settings.logoClear': 'Remove Logo',
  'pages.settings.logoClearConfirm': 'Remove the current logo?',
  'pages.settings.logoClearSuccess': 'Logo removed',
  'pages.settings.logoClearFailed': 'Failed to remove logo',
  'pages.settings.logoFileTooLarge': 'File size cannot exceed 2MB',
  'pages.settings.logoInvalidFormat':
    'Only PNG, JPEG, WebP, SVG formats are supported',
  'pages.settings.footerText': 'Footer Text',
  'pages.settings.footerTextTip':
    'Text shown in the footer of the admin panel',
  'pages.settings.relay': 'Relay Servers',
  'pages.settings.relay.description':
    'Relay servers (hbbr) that hbbs advertises to clients as the default relay. Clients without an explicit relay server will use these and automatically pick the fastest one. Format: host or host:port (default port 21117).',
  'pages.settings.relay.empty': 'No relay servers configured',
  'pages.settings.relay.add': 'Add',
  'pages.settings.relay.hostRequired': 'Enter relay host',
  'pages.settings.relay.alreadyExists': 'This relay server already exists',
  'pages.settings.relay.fetchFailed': 'Failed to load relay servers',
  'pages.settings.relay.saveSuccess':
    'Relay servers saved. hbbs will advertise them to clients.',
  'pages.settings.relay.saveFailed': 'Failed to save relay servers',
  'pages.settings.relay.online': 'online',
  'pages.settings.relay.offline': 'offline',
  'pages.settings.relay.clients': 'clients',
  'pages.settings.relay.remoteCountUnavailable':
    'Monitoring unavailable: relay agent is not installed on the remote server',
  'pages.settings.relay.totalActive': 'Active clients: {total}',
  'pages.settings.relay.checkedAt': 'Updated {time}',
  'pages.settings.relay.refresh': 'Refresh',
  'pages.settings.clientUpdate': 'Client Update',
  'pages.settings.clientUpdate.description':
    'The update command is sent only to the selected devices in the heartbeat response. In the "New Version" field, specify the version in 1.4.9 format — it is used to determine which devices are outdated. Provide a direct installer URL.',
  'pages.settings.clientUpdate.fetchFailed':
    'Failed to load client update settings',
  'pages.settings.clientUpdate.targetVersionRequired':
    'Specify the new version, e.g. 1.4.9',
  'pages.settings.clientUpdate.targetVersionInvalid':
    'Invalid version format. Use 1.4.9 (optionally 1.4.9-2)',
  'pages.settings.clientUpdate.urlRequired': 'Specify the installer URL',
  'pages.settings.clientUpdate.targetDevicesRequired':
    'Select at least one device to update',
  'pages.settings.clientUpdate.saveSuccess':
    'Settings saved. Clients will receive the command on their next heartbeat',
  'pages.settings.clientUpdate.saveFailed': 'Failed to save settings',
  'pages.settings.clientUpdate.clearSuccess': 'Client update disabled',
  'pages.settings.clientUpdate.clearFailed': 'Failed to disable client update',
  'pages.settings.clientUpdate.refreshed': 'Data updated',
  'pages.settings.clientUpdate.total': 'Total devices',
  'pages.settings.clientUpdate.outdated': 'Outdated (below new version)',
  'pages.settings.clientUpdate.matching': 'On new version',
  'pages.settings.clientUpdate.unknown': 'Unknown version',
  'pages.settings.clientUpdate.enabled': 'Enable client update',
  'pages.settings.clientUpdate.version': 'Version (shown to client)',
  'pages.settings.clientUpdate.versionTip':
    'e.g. 1.4.9 — shown to the client in the notification about the new version',
  'pages.settings.clientUpdate.targetVersion': 'New Version',
  'pages.settings.clientUpdate.targetVersionTip':
    'Version in 1.4.9 format (optionally 1.4.9-2). Devices with a lower version are considered outdated',
  'pages.settings.clientUpdate.url': 'Installer URL',
  'pages.settings.clientUpdate.message': 'Message to client',
  'pages.settings.clientUpdate.messagePlaceholder':
    'e.g. A new version of the client is available',
  'pages.settings.clientUpdate.targetDevices': 'Target devices',
  'pages.settings.clientUpdate.targetDevicesTip':
    'The command is sent only to the selected devices. No automatic broadcast to everyone',
  'pages.settings.clientUpdate.targetDevicesPlaceholder':
    'Select devices to update',
  'pages.settings.clientUpdate.save': 'Save',
  'pages.settings.clientUpdate.disable': 'Disable update',
  'pages.settings.clientUpdate.refresh': 'Refresh',
  'pages.settings.adminEmail': 'Admin Email',
  'pages.settings.language': 'Default Language',
  'pages.settings.security': 'Security Settings',
  'pages.settings.enable2FA': 'Enable Two-Factor Authentication',
  'pages.settings.sessionTimeout': 'Session Timeout (minutes)',
  'pages.settings.maxLoginAttempts': 'Max Login Attempts',
  'pages.settings.advanced': 'Advanced Settings',
  'pages.settings.logLevel': 'Log Level',
  'pages.settings.enableDebugMode': 'Enable Debug Mode',
  'pages.settings.fetchFailed': 'Failed to load settings',
  'pages.settings.saveSuccess': 'Settings saved successfully',
  'pages.settings.saveFailed': 'Failed to save settings',
  'pages.strategies.list': 'Strategy List',
  'pages.strategies.name': 'Strategy Name',
  'pages.strategies.note': 'Note',
  'pages.strategies.status': 'Status',
  'pages.strategies.create': 'Create Strategy',
  'pages.strategies.edit': 'Edit Strategy',
  'pages.strategies.deleteConfirm': 'Are you sure to delete this strategy?',
  'pages.strategies.createSuccess': 'Strategy created',
  'pages.strategies.createFailed': 'Failed to create strategy',
  'pages.strategies.updateSuccess': 'Strategy updated',
  'pages.strategies.updateFailed': 'Failed to update strategy',
  'pages.strategies.deleteSuccess': 'Strategy deleted',
  'pages.strategies.deleteFailed': 'Failed to delete strategy',
  'pages.strategies.enterName': 'Enter strategy name',
  'pages.strategies.configSummary': 'Config',
  'pages.strategies.configCount': '{modified}/{total} modified',
  'pages.strategies.modifiedAt': 'Modified At',
  'pages.strategies.createdAt': 'Created At',
  'pages.strategies.configOptions': 'Configuration Options',
  'pages.strategies.defaultLabel': 'Default',
  'pages.strategies.defaultValue': 'Default: {value}',
  'pages.strategies.resetToDefault': 'Reset to default',
  'pages.strategies.modifiedSummary': '{count} config(s) modified',
  'pages.strategies.resetAll': 'Reset All',
  'pages.strategies.assign': 'Assign',
  'pages.strategies.assignManagement': 'Assign Management',
  'pages.strategies.assignDevice': 'Device',
  'pages.strategies.assignUser': 'User',
  'pages.strategies.assignDeviceGroup': 'Device Group',
  'pages.strategies.assignedTargets': 'Assigned Targets',
  'pages.strategies.noAssigned': 'No assigned targets',
  'pages.strategies.addAssignment': 'Add Assignment',
  'pages.strategies.selectTarget': 'Select target',
  'pages.strategies.assignSuccess': 'Strategy assigned successfully',
  'pages.strategies.assignFailed': 'Failed to assign strategy',
  'pages.strategies.assignPartialFailed':
    'Assigned {success} target(s), {failed} failed: {errors}',
  'pages.strategies.unassignSuccess': 'Strategy unassigned successfully',
  'pages.strategies.unassignFailed': 'Failed to unassign strategy',
  'pages.strategies.unassignConfirm': 'Unassign this target?',
  'pages.strategies.fetchDetailFailed': 'Failed to fetch strategy details',
  'pages.strategies.updatedAt': 'Updated At',
  'pages.strategies.category.connection': 'Connection & Access',
  'pages.strategies.category.security': 'Security & Auth',
  'pages.strategies.category.display': 'Display & UI',
  'pages.strategies.category.av': 'Audio/Video & Codec',
  'pages.strategies.category.file': 'File & Clipboard',
  'pages.strategies.category.advanced': 'Advanced',
  'pages.strategies.category.floating': 'Floating Window',
  'pages.strategies.category.privacy': 'Privacy & Recording',
  'pages.strategies.category.hide': 'UI Hiding',
  'pages.users.inviteSuccess': 'Invitation sent',
  'pages.users.inviteFailed': 'Failed to send invitation',
  'pages.users.active': 'Active',
  'pages.users.disabled': 'Disabled',
  'pages.users.unverified': 'Unverified',
  'pages.users.roles': 'Roles',
  'pages.users.rolesInfo': 'User roles and permissions',
  'pages.users.strategy': 'Strategy',
  'pages.users.strategyInfo': 'Connection strategy for user',
  'pages.users.group': 'Group',
  'pages.users.groupInfo': 'User group assignment',
  'pages.users.groupName': 'Device Group',
  'pages.users.invite': 'Invite User',
  'pages.users.password': 'Password',
  'pages.users.isAdmin': 'Admin',
  'pages.users.normalUser': 'Normal',
  'pages.users.statusInfo': 'User account status',
  'pages.users.edit': 'Edit User',
  'pages.users.updateSuccess': 'User updated',
  'pages.users.updateFailed': 'Failed to update user',
  'pages.users.security': 'Security',
  'pages.users.securitySettings': 'Security Settings',
  'pages.users.securityUpdateSuccess': 'Security settings updated',
  'pages.users.securityUpdateFailed': 'Failed to update security settings',
  'pages.users.tfaEnforce': 'Enforce Two-Factor Authentication',
  'pages.users.emailVerification': 'Require Email Verification',
  'pages.users.forceLogout': 'Logout',
  'pages.users.forceLogoutSuccess': 'Force logout successful',
  'pages.users.forceLogoutFailed': 'Failed to force logout',
  'pages.users.thirdAuthType': 'Auth Type',
  'pages.users.createdAt': 'Created At',
  'pages.users.batchEnable': 'Batch Enable',
  'pages.users.batchDisable': 'Batch Disable',
  'pages.users.batchForceLogout': 'Batch Force Logout',
  'pages.users.batchEnableConfirm': 'Are you sure to enable selected users?',
  'pages.users.batchDisableConfirm': 'Are you sure to disable selected users?',
  'pages.users.batchForceLogoutConfirm':
    'Are you sure to force logout selected users?',
  'pages.users.batchEnableSuccess': 'Successfully enabled {count} user(s)',
  'pages.users.batchEnableFailed': 'Failed to enable users',
  'pages.users.batchEnablePartialFailed':
    'Successfully enabled {success} user(s), {failed} failed',
  'pages.users.batchDisableSuccess': 'Successfully disabled {count} user(s)',
  'pages.users.batchDisableFailed': 'Failed to disable users',
  'pages.users.batchDisablePartialFailed':
    'Successfully disabled {success} user(s), {failed} failed',
  'pages.users.batchForceLogoutSuccess': 'Batch force logout successful',
  'pages.users.batchForceLogoutFailed': 'Failed to force logout users',
  'pages.dashboard.totalUsers': 'Total Users',
  'pages.dashboard.activeUsers': 'Active Users',
  'pages.dashboard.totalDevices': 'Total Devices',
  'pages.dashboard.onlineDevices': 'Online Devices',
  'pages.dashboard.offlineDevices': 'Offline Devices',
  'pages.dashboard.todayConnections': 'Today Connections',
  'pages.dashboard.activeConnections': 'Active Connections',
  'pages.dashboard.edit': 'Customize',
  'pages.dashboard.editDone': 'Done',
  'pages.dashboard.moduleManager': 'Module Visibility',
  'pages.dashboard.moduleReset': 'Reset',
  'pages.dashboard.module.overview': 'Overview',
  'pages.dashboard.module.resource': 'Resources & Analysis',
  'pages.dashboard.module.operation': 'Operations Analysis',
  'pages.dashboard.module.systemStatus': 'System Status',
  'pages.dashboard.module.trends': 'Trends',
  'pages.dashboard.module.activeConnections': 'Active Connections',
  'pages.dashboard.module.recentEvents': 'Recent Events',
  'pages.dashboard.avgDuration': 'Avg Duration',
  'pages.dashboard.totalAlarms': 'Total Alarms',
  'pages.dashboard.criticalAlarms': 'Critical Alarms',
  'pages.dashboard.userDistribution': 'User Distribution',
  'pages.dashboard.adminUsers': 'Admin Users',
  'pages.dashboard.normalUsers': 'Normal Users',
  'pages.dashboard.deviceDistribution': 'Device Distribution',
  'pages.dashboard.connectionAnalysis': 'Connection Analysis',
  'pages.dashboard.successRate': 'Success Rate',
  'pages.dashboard.failureCount': 'Failure Count',
  'pages.dashboard.totalDuration': 'Total Duration',
  'pages.dashboard.fileTransfer': 'File Transfer',
  'pages.dashboard.transferredToday': 'Transferred Today',
  'pages.dashboard.totalSize': 'Total Size',
  'pages.dashboard.uploadCount': 'Upload Count',
  'pages.dashboard.downloadCount': 'Download Count',
  'pages.dashboard.systemStatus': 'System Status',
  'pages.dashboard.uptime': 'Uptime',
  'pages.dashboard.trendData': 'Trend Data',
  'pages.dashboard.connectionTrend': 'Connection Trend',
  'pages.dashboard.userActiveTrend': 'User Active Trend',
  'pages.dashboard.alarmTrend': 'Alarm Trend',
  'pages.dashboard.recentEvents': 'Recent Events',
  'pages.dashboard.user': 'User',
  'pages.dashboard.device': 'Device',
  'pages.dashboard.duration': 'Duration',
  'pages.dashboard.minutes': 'min',
  'pages.dashboard.startTime': 'Start Time',
  'pages.dashboard.eventType': 'Type',
  'pages.dashboard.action': 'Action',
  'pages.dashboard.target': 'Target',
  'pages.dashboard.status': 'Status',
  'pages.dashboard.time': 'Time',
  'pages.dashboard.event.connection': 'Connection',
  'pages.dashboard.event.file': 'File',
  'pages.dashboard.event.established': 'Established',
  'pages.dashboard.event.close': 'Closed',
  'pages.dashboard.event.send': 'Send',
  'pages.dashboard.event.receive': 'Receive',
  'pages.dashboard.event.success': 'Success',
  'pages.dashboard.event.failed': 'Failed',
  'pages.dashboard.event.warning': 'Warning',
  'pages.dashboard.event.unknown': 'Unknown',
  'pages.common.pleaseEnterName': 'Please enter name',
  'pages.common.pleaseEnterId': 'Please enter ID',
  'pages.common.pleaseEnterTagName': 'Please enter tag name',
  'pages.common.pleaseEnterUsername': 'Please enter username',
  'pages.common.pleaseEnterEmail': 'Please enter email',
  'pages.common.pleaseEnterValidEmail': 'Please enter valid email',
  'pages.common.pleaseEnterPassword': 'Please enter password',
  'pages.common.pleaseEnterRoleName': 'Please enter role name',
  'pages.common.id': 'ID',
  'pages.dashboard.min': 'min',
  'pages.dashboard.cpu': 'CPU',
  'pages.dashboard.memory': 'Memory',
  'pages.dashboard.disk': 'Disk',
  'pages.dashboard.inactive': 'Inactive',
  'pages.dashboard.onlineRate': 'Online Rate',
  'pages.dashboard.connectionCount': 'Count',
  'pages.dashboard.newUsers': 'New Users',
  'pages.dashboard.7days': '7 Days',
  'pages.dashboard.30days': '30 Days',
  'pages.dashboard.90days': '90 Days',
  'pages.dashboard.noData': 'No data',
  'pages.dashboard.resourceDistribution': 'Resource Distribution',
  'pages.dashboard.operationAnalysis': 'Operation Analysis',
  'pages.dashboard.module.typeDistribution': 'Connection Types',
  'pages.dashboard.module.deviceInfo': 'Devices: OS & Version',
  'pages.dashboard.module.topDevicesUsers': 'Top Devices & Users',
  'pages.dashboard.module.connectionQuality': 'Connection Quality',
  'pages.dashboard.module.hourlyPattern': 'Activity by Hour',
  'pages.dashboard.module.geoDistribution': 'Geography',
  'pages.dashboard.module.uptime': 'Device Uptime',
  'pages.dashboard.typeDistribution': 'Connection Types',
  'pages.dashboard.connType.remote_control': 'Remote Control',
  'pages.dashboard.connType.file_transfer': 'File Transfer',
  'pages.dashboard.connType.port_forward': 'Port Forward',
  'pages.dashboard.connType.camera': 'Camera',
  'pages.dashboard.connType.terminal': 'Terminal',
  'pages.dashboard.connType.not_established': 'Not Established',
  'pages.dashboard.connType.unknown': 'Unknown',
  'pages.dashboard.deviceInfoDistribution': 'Devices by OS & Version',
  'pages.dashboard.byOs': 'By OS',
  'pages.dashboard.byVersion': 'By Client Version',
  'pages.dashboard.outdatedHint': 'Below the configured target version',
  'pages.dashboard.outdatedVersion': 'outdated',
  'pages.dashboard.topDevicesUsers': 'Top Devices & Users',
  'pages.dashboard.topDevices': 'Top Devices',
  'pages.dashboard.topUsers': 'Top Users',
  'pages.dashboard.connectionQuality': 'Connection Quality',
  'pages.dashboard.hourlyPattern': 'Activity by Hour',
  'pages.dashboard.hourlyHint': 'last 30 days',
  'pages.dashboard.geoDistribution': 'Geography',
  'pages.dashboard.geoLocation': 'Location',
  'pages.dashboard.geoCountry': 'Country',
  'pages.dashboard.geoShare': 'Share',
  'pages.dashboard.geoDevices': 'Devices',
  'pages.dashboard.geoConnections': 'Connections',
  'pages.dashboard.geoEmpty': 'No geography data yet (local GeoIP database)',
  'pages.dashboard.deviceUptime': 'Device Uptime',
  'pages.dashboard.uptime24h': '24h',
  'pages.dashboard.uptime7d': '7 days',
  'pages.dashboard.uptimeEmpty':
    'Uptime data is being collected (snapshots every 5 minutes)',
  'pages.dashboard.deviceOnlineTrend': 'Device Online Trend',
  'pages.dashboard.fileTransferTrend': 'File Transfer Trend',
  'pages.smtp.title': 'SMTP Configuration',
  'pages.smtp.description':
    'Configure SMTP mail server for sending system notification emails',
  'pages.smtp.host': 'Server Address',
  'pages.smtp.hostPlaceholder': 'Please enter SMTP server address',
  'pages.smtp.port': 'Port',
  'pages.smtp.portPlaceholder': 'Please enter port number',
  'pages.smtp.secure': 'Use SSL/TLS',
  'pages.smtp.secureHelp':
    'Enable secure connection (usually port 465 uses SSL, port 587 uses TLS)',
  'pages.smtp.user': 'Username',
  'pages.smtp.userPlaceholder': 'Please enter SMTP authentication username',
  'pages.smtp.password': 'Password',
  'pages.smtp.passwordPlaceholder': 'Please enter SMTP authentication password',
  'pages.smtp.from': 'Sender Email',
  'pages.smtp.fromPlaceholder': 'Please enter sender email address',
  'pages.smtp.enabled': 'Enable Configuration',
  'pages.smtp.enabledHelp':
    'When enabled, this configuration will be used to send system emails',
  'pages.smtp.testConnection': 'Test Connection',
  'pages.smtp.testSuccess': 'SMTP connection test successful',
  'pages.smtp.testFailed': 'SMTP connection test failed',
  'pages.smtp.saveSuccess': 'SMTP configuration saved successfully',
  'pages.smtp.saveFailed': 'Failed to save SMTP configuration',
  'pages.smtp.createdAt': 'Created At',
  'pages.smtp.updatedAt': 'Updated At',
  'pages.addressBook.color': 'Color',
  'pages.addressBook.deviceInfo': 'username@device_name',
  'pages.addressBook.manageTags': 'Manage Tags',
  'pages.addressBook.newTagName': 'New Tag Name',
  'pages.addressBook.peerUpdateFailed': 'Failed to update peer',
  'pages.addressBook.peerUpdated': 'Peer updated',
  'pages.addressBook.renameTag': 'Rename Tag',
  'pages.addressBook.selectTags': 'Select tags',
  'pages.addressBook.tagColorUpdateFailed': 'Failed to update tag color',
  'pages.addressBook.tagRenameFailed': 'Failed to rename tag',
  'pages.addressBook.tagRenamed': 'Tag renamed',
  'pages.addressBook.untagged': 'Untagged',
  'pages.common.cancel': 'No',
  'pages.common.confirm': 'Yes',
  'pages.common.enterDescription': 'Enter description',
  'pages.common.rename': 'Rename',
  'pages.common.save': 'Save',
  'pages.customClients.enterName': 'Enter client name',
  'pages.settings.chinese': 'Chinese',
  'pages.settings.english': 'English',
  'pages.settings.russian': 'Russian',
  'pages.settings.enterAdminEmail': 'Enter admin email',
  'pages.settings.enterSiteName': 'Enter site name',
  'pages.settings.logError': 'Error',
  'pages.settings.logInfo': 'Info',
  'pages.settings.logWarning': 'Warning',
  'pages.userGroups.enterName': 'Enter group name',
  'pages.users.admin': 'Admin',
  'pages.users.me': 'Me',
  'pages.oidcProviders.list': 'OIDC Providers',
  'pages.oidcProviders.sort': 'Sort',
  'pages.oidcProviders.name': 'Provider Name',
  'pages.oidcProviders.type': 'Type',
  'pages.oidcProviders.issuer': 'Issuer URL',
  'pages.oidcProviders.clientId': 'Client ID',
  'pages.oidcProviders.clientSecret': 'Client Secret',
  'pages.oidcProviders.scope': 'Scope',
  'pages.oidcProviders.authorizationEndpoint': 'Authorization Endpoint',
  'pages.oidcProviders.tokenEndpoint': 'Token Endpoint',
  'pages.oidcProviders.userinfoEndpoint': 'Userinfo Endpoint',
  'pages.oidcProviders.jwksUri': 'JWKS URI',
  'pages.oidcProviders.enabled': 'Enabled',
  'pages.oidcProviders.priority': 'Priority',
  'pages.oidcProviders.endpointConfig': 'Endpoint Configuration',
  'pages.oidcProviders.create': 'Create Provider',
  'pages.oidcProviders.edit': 'Edit Provider',
  'pages.oidcProviders.test': 'Test',
  'pages.oidcProviders.testResult': 'Test Connection Result',
  'pages.oidcProviders.discoveredEndpoints': 'Discovered Endpoints',
  'pages.oidcProviders.enterName': 'Enter provider name',
  'pages.oidcProviders.enterIssuer': 'Enter issuer URL',
  'pages.oidcProviders.enterClientId': 'Enter client ID',
  'pages.oidcProviders.enterClientSecret': 'Enter client secret',
  'pages.oidcProviders.enterEndpoint': 'Auto-discovered if empty',
  'pages.oidcProviders.createSuccess': 'OIDC provider created',
  'pages.oidcProviders.createFailed': 'Failed to create OIDC provider',
  'pages.oidcProviders.updateSuccess': 'OIDC provider updated',
  'pages.oidcProviders.updateFailed': 'Failed to update OIDC provider',
  'pages.oidcProviders.deleteSuccess': 'OIDC provider deleted',
  'pages.oidcProviders.deleteFailed': 'Failed to delete OIDC provider',
  'pages.oidcProviders.deleteConfirm': 'Are you sure to delete this provider?',
  'pages.oidcProviders.enableSuccess': 'OIDC provider enabled',
  'pages.oidcProviders.enableFailed': 'Failed to enable OIDC provider',
  'pages.oidcProviders.disableSuccess': 'OIDC provider disabled',
  'pages.oidcProviders.disableFailed': 'Failed to disable OIDC provider',
  'pages.oidcProviders.enableConfirm': 'Are you sure to enable this provider?',
  'pages.oidcProviders.disableConfirm':
    'Are you sure to disable this provider?',
  'pages.oidcProviders.testFailed': 'Failed to test OIDC connection',
  'pages.oidcProviders.fetchDetailFailed': 'Failed to fetch provider details',
  'pages.oidcProviders.sortFailed': 'Failed to update provider order',
  'pages.account.tab.basic': 'Basic Information',
  'pages.account.tab.avatar': 'Avatar',
  'pages.account.tab.security': 'Security',
  'pages.account.basicInfo.title': 'Basic Information',
  'pages.account.basicInfo.displayName': 'Display Name',
  'pages.account.basicInfo.displayNamePlaceholder': 'Enter display name',
  'pages.account.basicInfo.name': 'Username',
  'pages.account.basicInfo.email': 'Email',
  'pages.account.basicInfo.note': 'Note',
  'pages.account.basicInfo.updateSuccess': 'Profile updated successfully',
  'pages.account.basicInfo.updateFailed': 'Failed to update profile',
  'pages.account.avatar.title': 'Avatar Settings',
  'pages.account.avatar.hint':
    'Supports JPG, PNG, WebP, max 2MB, will be resized to 256x256',
  'pages.account.avatar.upload': 'Upload Avatar',
  'pages.account.avatar.delete': 'Delete Avatar',
  'pages.account.avatar.deleteConfirm': 'Are you sure to delete your avatar?',
  'pages.account.avatar.uploadSuccess': 'Avatar uploaded successfully',
  'pages.account.avatar.uploadFailed': 'Failed to upload avatar',
  'pages.account.avatar.deleteSuccess': 'Avatar deleted successfully',
  'pages.account.avatar.deleteFailed': 'Failed to delete avatar',
  'pages.account.avatar.fileTooLarge': 'File size cannot exceed 2MB',
  'pages.account.avatar.invalidFormat':
    'Only JPG, PNG, WebP formats are supported',
  'pages.account.security.title': 'Security Settings',
  'pages.account.security.2faStatus': '2FA Status',
  'pages.account.security.2faAction': 'Action',
  'pages.account.security.enabled': 'Enabled',
  'pages.account.security.disabled': 'Disabled',
  'pages.account.security.enable2FA': 'Enable 2FA',
  'pages.account.security.disable2FA': 'Disable 2FA',
  'pages.account.security.setup2FA': 'Setup Two-Factor Authentication',
  'pages.account.security.setupFailed': 'Failed to setup 2FA',
  'pages.account.security.scanQRCode':
    'Scan the QR code with your authenticator app, then enter the verification code below.',
  'pages.account.security.secretKey': 'Secret Key',
  'pages.account.security.verificationCode': 'Verification Code',
  'pages.account.security.enterCode': 'Please enter verification code',
  'pages.account.security.verifyAndEnable': 'Verify & Enable',
  'pages.account.security.enableSuccess': '2FA enabled successfully',
  'pages.account.security.enableFailed': 'Failed to enable 2FA',
  'pages.account.security.currentCode': 'Current Verification Code',
  'pages.account.security.confirmDisable': 'Confirm Disable',
  'pages.account.security.disableSuccess': '2FA disabled successfully',
  'pages.account.security.disableFailed': 'Failed to disable 2FA',
  'pages.account.security.password': 'Login Password',
  'pages.account.security.passwordSet': 'Set',
  'pages.account.security.passwordNotSet': 'Not Set',
  'pages.account.security.changePassword': 'Change Password',
  'pages.account.security.currentPassword': 'Current Password',
  'pages.account.security.enterCurrentPassword':
    'Please enter current password',
  'pages.account.security.newPassword': 'New Password',
  'pages.account.security.enterNewPassword':
    'Please enter new password (min 6 characters)',
  'pages.account.security.confirmNewPassword': 'Confirm New Password',
  'pages.account.security.confirmNewPasswordPlaceholder':
    'Please re-enter new password',
  'pages.account.security.passwordMinLength':
    'Password must be at least 6 characters',
  'pages.account.security.passwordMismatch': 'The two passwords do not match',
  'pages.account.security.changePasswordSuccess':
    'Password changed successfully',
  'pages.account.security.changePasswordFailed': 'Failed to change password',
  'pages.account.security.thirdPartyUser':
    'Third-party login users cannot change password',
  'pages.account.security.noPasswordUser': 'No password set for this account',
  'pages.account.security.passkey.title': 'Passkey Management',
  'pages.account.security.passkey.register': 'Register Passkey',
  'pages.account.security.passkey.registerSuccess':
    'Passkey registered successfully',
  'pages.account.security.passkey.registerFailed': 'Failed to register Passkey',
  'pages.account.security.passkey.deleteSuccess':
    'Passkey deleted successfully',
  'pages.account.security.passkey.deleteFailed': 'Failed to delete Passkey',
  'pages.account.security.passkey.deleteConfirm':
    'Are you sure to delete this Passkey?',
  'pages.account.security.passkey.name': 'Name',
  'pages.account.security.passkey.namePlaceholder': 'e.g. MacBook Touch ID',
  'pages.account.security.passkey.namePasskey': 'Name your Passkey',
  'pages.account.security.passkey.deviceType': 'Device Type',
  'pages.account.security.passkey.multiDevice': 'Multi-device',
  'pages.account.security.passkey.singleDevice': 'Single-device',
  'pages.account.security.passkey.createdAt': 'Created At',
  'pages.account.security.passkey.noCredentials': 'No Passkeys registered',
  'pages.account.security.sessions.title': 'Login Sessions',
  'pages.account.security.sessions.device': 'Device',
  'pages.account.security.sessions.type': 'Type',
  'pages.account.security.sessions.browser': 'Browser',
  'pages.account.security.sessions.client': 'Client',
  'pages.account.security.sessions.os': 'OS',
  'pages.account.security.sessions.createdAt': 'Created At',
  'pages.account.security.sessions.expiresAt': 'Expires At',
  'pages.account.security.sessions.current': 'Current',
  'pages.account.security.sessions.revoke': 'Revoke',
  'pages.account.security.sessions.revokeConfirm':
    'Are you sure to revoke this session?',
  'pages.account.security.sessions.revokeSuccess':
    'Session revoked successfully',
  'pages.account.security.sessions.revokeFailed': 'Failed to revoke session',
  'pages.account.security.sessions.cannotRevokeCurrent':
    'Cannot revoke current session',
  'pages.account.security.sessions.noSessions': 'No active sessions',
  'pages.ldap.title': 'LDAP Configuration',
  'pages.ldap.description':
    'Configure LDAP/Active Directory authentication. Users will be automatically authenticated via LDAP when enabled.',
  'pages.ldap.urls': 'Server URLs',
  'pages.ldap.urlsRequired': 'Please enter at least one LDAP server URL',
  'pages.ldap.urlPlaceholder': 'e.g. ldaps://ad.example.com:636',
  'pages.ldap.addUrl': 'Add Server URL',
  'pages.ldap.bindDN': 'Bind DN',
  'pages.ldap.bindDNRequired': 'Please enter the service account Bind DN',
  'pages.ldap.bindDNPlaceholder':
    'e.g. CN=svc-ldap,OU=ServiceAccounts,DC=example,DC=com',
  'pages.ldap.bindCredentials': 'Bind Password',
  'pages.ldap.bindCredentialsRequired':
    'Please enter the service account password',
  'pages.ldap.bindCredentialsPlaceholder':
    'Please enter the service account password',
  'pages.ldap.searchBase': 'Search Base DN',
  'pages.ldap.searchBaseRequired': 'Please enter the search base DN',
  'pages.ldap.searchBasePlaceholder': 'e.g. DC=example,DC=com',
  'pages.ldap.searchFilter': 'Search Filter',
  'pages.ldap.searchFilterRequired': 'Please enter the search filter',
  'pages.ldap.searchFilterHelp':
    'Use {{username}} as the username placeholder. AD: (sAMAccountName={{username}}), OpenLDAP: (uid={{username}})',
  'pages.ldap.searchFilterPlaceholder': 'e.g. (sAMAccountName={{username}})',
  'pages.ldap.searchAttributes': 'Search Attributes',
  'pages.ldap.searchAttributePlaceholder':
    'e.g. dn, sAMAccountName, mail, displayName',
  'pages.ldap.addAttribute': 'Add Attribute',
  'pages.ldap.groupSearchBase': 'Group Search Base DN',
  'pages.ldap.groupSearchBasePlaceholder': 'e.g. OU=Groups,DC=example,DC=com',
  'pages.ldap.groupSearchFilter': 'Group Search Filter',
  'pages.ldap.groupSearchFilterHelp':
    'Use {{dn}} as the user DN placeholder. e.g. (member={{dn}})',
  'pages.ldap.groupSearchFilterPlaceholder': 'e.g. (member={{dn}})',
  'pages.ldap.adminGroups': 'Admin Groups',
  'pages.ldap.adminGroupsHelp':
    'Users in these LDAP groups will be mapped as administrators (case-insensitive match)',
  'pages.ldap.adminGroupPlaceholder':
    'e.g. CN=Admins,OU=Groups,DC=example,DC=com',
  'pages.ldap.addAdminGroup': 'Add Admin Group',
  'pages.ldap.tlsOptions': 'TLS Options',
  'pages.ldap.tlsCa': 'CA Certificate (PEM)',
  'pages.ldap.tlsCaPlaceholder': '-----BEGIN CERTIFICATE-----\n...',
  'pages.ldap.tlsCert': 'Client Certificate (PEM)',
  'pages.ldap.tlsCertPlaceholder': '-----BEGIN CERTIFICATE-----\n...',
  'pages.ldap.tlsKey': 'Client Private Key (PEM)',
  'pages.ldap.tlsKeyPlaceholder': '-----BEGIN PRIVATE KEY-----\n...',
  'pages.ldap.tlsServername': 'SNI Server Name',
  'pages.ldap.tlsServernamePlaceholder': 'Server Name Indication for TLS',
  'pages.ldap.enabled': 'Enable LDAP Authentication',
  'pages.ldap.enabledHelp':
    'When enabled, users will be authenticated against the LDAP server. Existing LDAP-linked users will always use LDAP authentication regardless of this setting.',
  'pages.ldap.testConnection': 'Test Connection',
  'pages.ldap.testSuccess': 'LDAP connection test successful',
  'pages.ldap.testFailed': 'LDAP connection test failed',
  'pages.ldap.saveSuccess': 'LDAP configuration saved successfully',
  'pages.ldap.saveFailed': 'Failed to save LDAP configuration',
  'pages.ldap.createdAt': 'Created At',
  'pages.ldap.updatedAt': 'Updated At',
  'pages.nexus.repoRequired': 'Repository Interaction Required',
  'pages.nexus.repoRequiredDesc':
    'You need to Star, Fork or Watch the databk/rustdesk-console repository on GitHub before generating custom clients. It may take up to 5 minutes for the cache to refresh.',
  'pages.nexus.goToRepo': 'Go to GitHub Repository',
  'pages.nexus.buildList': 'Build History',
  'pages.nexus.createBuild': 'Create New Client',
  'pages.nexus.noBuilds': 'No build records',
  'pages.nexus.createBuildTitle': 'Create Custom Client',
  'pages.nexus.customConfig': 'Custom Configuration',
  'pages.nexus.serverConfig': 'Server Configuration',
  'pages.nexus.password': 'Password',
  'pages.nexus.passwordPlaceholder': 'Enter password',
  'pages.nexus.salt': 'Salt',
  'pages.nexus.saltPlaceholder': 'Enter salt',
  'pages.nexus.connType': 'Connection Type',
  'pages.nexus.disableInstallation': 'Disable Installation',
  'pages.nexus.disableSettings': 'Disable Settings',
  'pages.nexus.disableAccount': 'Disable Account',
  'pages.nexus.disableAb': 'Disable AB',
  'pages.nexus.disableTcpListen': 'Disable TCP Listen',
  'pages.nexus.rendezvousServer': 'ID Server',
  'pages.nexus.relayServer': 'Relay Server',
  'pages.nexus.key': 'Key',
  'pages.nexus.apiServer': 'API Server',
  'pages.nexus.overrideSettings': 'Override Settings',
  'pages.nexus.defaultSettings': 'Default Settings',
  'pages.nexus.settingType': 'Setting Type',
  'pages.nexus.deleteBuildConfirm':
    'Are you sure you want to delete this build record?',
  'pages.nexus.deleteSuccess': 'Build record deleted',
  'pages.nexus.deleteFailed': 'Failed to delete build record',
  'pages.nexus.pollingBuildStatus': 'Polling build status...',
  'pages.nexus.uuid': 'UUID',
  'pages.nexus.concurrentLimit': 'Only one build at a time',
  'pages.nexus.os': 'Operating System',
  'pages.nexus.arch': 'Architecture',
  'pages.nexus.appName': 'Application Name',
  'pages.nexus.enterAppName': 'Please enter application name',
  'pages.nexus.appNamePlaceholder': 'e.g. my-rustdesk',
  'pages.nexus.appNameHint': 'Only English letters allowed',
  'pages.nexus.submitBuild': 'Submit Build',
  'pages.nexus.bindSuccess': 'Github account bound successfully',
  'pages.nexus.bindFailed': 'Failed to bind Github account',
  'pages.nexus.createLoginFailed': 'Failed to create login session',
  'pages.nexus.unbindConfirm': 'Unbind Github Account',
  'pages.nexus.unbindConfirmContent':
    'Are you sure you want to unbind your Github account? You will need to re-bind to generate custom clients.',
  'pages.nexus.unbindSuccess': 'Github account unbound',
  'pages.nexus.unbindFailed': 'Failed to unbind Github account',
  'pages.nexus.tokenExpired': 'Github Token Expired',
  'pages.nexus.tokenExpiredDesc':
    'Your Github token for {username} has expired. Please re-bind your account.',
  'pages.nexus.rebind': 'Re-bind Github Account',
  'pages.nexus.bindTitle': 'Bind Github Account',
  'pages.nexus.bindDesc':
    'You need to bind your GitHub account to generate custom clients. Click the button below to authorize via GitHub.',
  'pages.nexus.bindGithub': 'Authorize with GitHub',
  'pages.nexus.unbind': 'Unbind',
  'pages.nexus.repoInteractionRequired':
    'Please Star, Fork or Watch the databk/rustdesk-console repository on GitHub first. It may take up to 5 minutes for the cache to refresh.',
  'pages.nexus.buildAlreadyRunning': 'You already have a build in progress',
  'pages.nexus.generateFailed': 'Failed to submit build request',
  'pages.nexus.downloadFailed': 'Failed to download custom client',
  'pages.nexus.download': 'Download',
  'pages.nexus.buildAgain': 'Build Again',
  'pages.nexus.status': 'Status',
  'pages.nexus.statusPending': 'Build Pending',
  'pages.nexus.statusPendingDesc':
    'Your build request has been submitted and is waiting to be processed...',
  'pages.nexus.statusBuilding': 'Building',
  'pages.nexus.statusBuildingDesc':
    'GitHub Actions is building your custom client. This may take several minutes...',
  'pages.nexus.statusCompleted': 'Build Completed',
  'pages.nexus.statusCompletedDesc':
    'Your custom client is ready for download.',
  'pages.nexus.statusFailed': 'Build Failed',
  'pages.nexus.statusFailedDesc': 'The build process encountered an error.',
  'pages.nexus.statusCancelled': 'Build Cancelled',
  'pages.nexus.statusCancelledDesc':
    'The build was cancelled, usually because you un-starred/un-forked the repository.',
  'pages.nexus.bindWhyLogin':
    'GitHub authentication helps us verify that you are a real user, preventing automated abuse of build resources. We only request your public data — no access to your repositories, personal data, or any other permissions is needed.',
  'pages.nexus.repoWhyInteract':
    "I'm a high school student developing this project in my spare time. Your Star, Fork, or Watch means a lot to me — it not only keeps me motivated, but also helps with my college applications. This is the only thing I ask for in return. Thank you so much for your support!",
  'pages.health.title': 'System Health',
  'pages.health.cpu': 'CPU',
  'pages.health.memory': 'Memory',
  'pages.health.disk': 'Disk',
  'pages.health.services': 'Services',
  'pages.health.containers': 'Containers',
  'pages.health.ssl': 'SSL Certificate',
  'pages.health.domain': 'Domain',
  'pages.health.issuer': 'Issuer',
  'pages.health.expires': 'Expires',
  'pages.health.daysLeft': 'Days left',
  'pages.health.database': 'Database',
  'pages.health.dbSize': 'Size',
  'pages.health.peersTotal': 'Total devices',
  'pages.health.peersOnline': 'Online devices',
  'pages.health.hostname': 'Host',
  'pages.health.uptime': 'Uptime',
  'pages.health.lastUpdate': 'Updated',
  'pages.health.fetchFailed': 'Failed to fetch system health',
  'pages.health.hostUnavailable': 'Server data unavailable. Check that health-check.sh runs on the host.',
};
